<script setup lang="ts">
import { useSettingStore } from '@/stores/setting'
import { storeToRefs } from 'pinia'
import { ref } from 'vue'
import IconSidebar from '@/components/icons/IconSidebar.vue'
import IconLogo from '@/components/icons/IconLogo.vue'
import { useRouter } from 'vue-router'
import { resolveMenuIcon } from '@/layouts/menu-icons'
const rail = ref(true)
const settingStore = useSettingStore()
const { currentMenu, menus } = storeToRefs(settingStore)
const router = useRouter()
const handleChangeMenu = (menu: string) => {
  currentMenu.value = menu
}

const handleLogoClick = () => {
  router.push({ name: 'home' })
}
</script>

<template>
  <v-navigation-drawer permanent class="sidebar" :rail="rail" @click="rail = false" rail-width="64">
    <div class="sidebar-menu d-flex flex-column" style="gap: var(--sds-size-space-24)">
      <div
        class="sidebar-header"
        :style="{
          padding: rail ? '0' : '0 var(--sds-size-space-16) 0 var(--sds-size-space-24)',
          justifyContent: rail ? 'center' : 'space-between',
        }"
      >
        <IconLogo
          variant="rail"
          v-if="rail"
          @click.stop="handleLogoClick"
          style="cursor: pointer"
        />
        <IconLogo v-else @click.stop="handleLogoClick" style="cursor: pointer" />

        <IconSidebar v-if="!rail" class="clickable" @click.stop="rail = !rail" />
      </div>

      <div>
        <div
          v-for="(menu, index) in menus"
          :key="index"
          @click.stop="handleChangeMenu(menu.value)"
          class="sidebar-menu-item d-flex align-center py-2 px-3 tw:transition-all tw:duration-500"
          :class="{
            active: currentMenu === menu.value,
          }"
          :style="{
            justifyContent: rail ? 'center' : 'flex-start',
            gap: rail ? '0' : '8px',
          }"
        >
          <div></div>
          <component :is="resolveMenuIcon(menu.iconKey)" style="width: 20px; height: 20px" />

          <span v-if="!rail" class="text-body-small">{{ menu.title }}</span>

          <v-tooltip v-if="rail" activator="parent" location="right">{{ menu.title }}</v-tooltip>
        </div>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<style scoped lang="scss">
.sidebar {
  width: 210px;
  border-right: 1px solid var(--sds-color-border-default-secondary);
  background: var(--sds-color-background-surface-secondary) !important;
}
.sidebar-header {
  height: 57px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--sds-color-border-default-secondary);
  padding: 0 var(--sds-size-space-16) 0 var(--sds-size-space-24);
}
.sidebar-menu-item {
  color: var(--sds-color-text-default-tertiary);
  --padding-y: 8px;
  --padding-x: 12px;
  height: 56px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    pointer-events: none;

    background:
      url('@/assets/svg/corner-tl.svg') calc(0% + var(--padding-x)) calc(0% + var(--padding-y)) /
        6px 6px no-repeat,
      url('@/assets/svg/corner-tr.svg') calc(100% - var(--padding-x)) calc(0% + var(--padding-y)) /
        6px 6px no-repeat,
      url('@/assets/svg/corner-bl.svg') calc(0% + var(--padding-x)) calc(100% - var(--padding-y)) /
        6px 6px no-repeat,
      url('@/assets/svg/corner-br.svg') calc(100% - var(--padding-x))
        calc(100% - var(--padding-y)) / 6px 6px no-repeat;

    opacity: 0;
    transform: scale(0.98);
    transition:
      opacity 300ms ease,
      transform 300ms ease;
    /* hoặc: transition: opacity 300ms ease; */
  }

  &.active,
  &:hover {
    color: var(--sds-color-border-brand-green);
    background: var(--sds-color-background-opacity-100);
    cursor: pointer;

    &::before {
      opacity: 1;
      transform: scale(1);
    }
  }
}
</style>
